import MetricCategoryItem, { MetricCategoryItemStrings } from 'enums/MetricCategoryItem'

export const resolveValueFromMetric = (name: MetricCategoryItemStrings) => {
  switch (name) {
    case MetricCategoryItem.TEN_SCORE:
      return [10]
    case MetricCategoryItem.HIGH_SCORE:
      return [7, 8, 9]
    case MetricCategoryItem.MEDIUM_SCORE:
      return [4, 5, 6]
    case MetricCategoryItem.LOW_SCORE:
      return [1, 2, 3]
    case MetricCategoryItem.NO_SCORE:
      return [0]
    case MetricCategoryItem.NO_RESPONSE_SURVEY:
    default:
      return [-1]
  }
}

export default resolveValueFromMetric
